import React from "react";
import googleImg from "../../../images/Google.png";
import { sendEvent } from "../../../utils/event";

const GoogleLoginNative = () => {
  const login = () => {
    sendEvent("Googlee");
  };

  return (
    <div className="googleLoginButton" style={{ width: "100%" }}>
      <button
        onClick={login}
        className="mt-1 secondary-button text-black px-4 items-center !justify-center flex h-11 border border-gray-300"
      >
        <img
          src={googleImg}
          className=" w-7 inline-block mx-1"
          alt="Google-logo"
        />
        <span className="">Continue With Google</span>
      </button>
    </div>
  );
};

export default GoogleLoginNative;
